import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20flowing%20orange%20and%20gold%20waves%2C%20soft%20geometric%20shapes%2C%20modern%20tech%20aesthetic%2C%20smooth%20elegant%20texture%2C%20minimalist%20dark%20background%20with%20warm%20highlights&width=1800&height=600&seq=cta-pg-simulator&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/90 to-secondary-800/85"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-white mb-4">
          准备好开始你的 <span className="text-primary-400">PG模拟器</span> 之旅了吗？
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 max-w-xl mx-auto">
          立即加入50万+玩家的行列，无需下载，免费畅玩200+款精品游戏
        </p>
        <Link
          to="/category/jingdian"
          className="inline-flex items-center px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-heading text-lg rounded-full whitespace-nowrap cursor-pointer transition-all hover:scale-105"
        >
          <i className="ri-gamepad-line mr-2"></i>免费开始体验
        </Link>
      </div>
    </section>
  );
}